import React from "react";

const Terms = () => {

  return (
    <div className="container bg-white border rounded shadow p-4">

      <div className="row">

        <div className="col-8">

          <div className="mt-4 px-3" style={{ wordSpacing: "2px", lineHeight: "31px" }}>
            <div>
              <h5 className="text-center mb-4">
                شرایط ثبت آگهی

              </h5>
              <p>
                در نظر داشته باشید، به منظور تسهیل و تسریع فرآیند انتشار آگهی‌ها، صنعتبان ممکن است در
                مواردی بر اساس قوانین، متن یا عنوان آگهی شما را به طور جزئی تغییر دهد. همچنین صنعتبان
                مجاز است هرگونه پیام، آگهی و یا عکسی که به این سایت ارسال میکنید یا هر حساب کاربری و
                اطلاعات دیگری که مربوط به شما یا ایجاد شده توسط شما باشد را هر زمان و به هر شکلی که
                ضروری بداند حذف نماید .
                <br />
                چنانچه از ناحیه مراجع ذیصلاح قانونی دستور حذف آگهی صادر شده باشد، صنعتبان فوراً اقدام
                به حذف آگهی مینماید. همچنین در صورتی که گزارش تخلف کاربران نسبت به آگهی بیشتر از 5
                مورد باشد، صنعتبان به صلاحدید خود ممکن است اقدام به حذف آگهی نماید. در دو فرض اخیر
                صنعتبان هیچگونه مسئولیتی در قبال بازپرداخت هزینههای پرداختی بابت آگهی حذف شده به
                کاربر ندارد.
                <br />
                گهیدهندگان با ثبت آگهی خود در صنعتبان تأیید میکنند که آگهی ایشان شامل مواردی که در
                ادامه آورده میشوند نخواهد بود و همچنین دارای سن بالای ۱۸ سال هستند.
              </p>
              <ul className="pe-4 mt-3">
                <li> مغایرت با قوانین جاری جمهوری اسلامی ایران و عرف جامعه </li>
                <li>  نقض حریم شخصی افراد  </li>
                <li> آگهی‌های فروشی بدون تصویر  </li>
                <li> استفاده از عبارتها یا کلماتی مانند: فروش، ویژه، نو، زیر قیمت، استثنائی،  و موارد مشابه  </li>
                <li> هر گونه توهین به ادیان رسمی کشور، آداب، رسوم، قومیت‌ها، لهجه‌ها و گویش‌های مختلف  </li>
                <li>استفاده ابزاری از تصاویر اشخاص در آگهی، درج بیمورد عکس صورت اشخاص یا استفاده
                  از عکس کودکان برای معرفی کالا و خدماتی که مخاطب آن کودکان نیستند</li>
                <li>استفاده از حروف و زبان انگلیسی برای آگهی‌های فارسی</li>
                <li>هر نوع آگهی و خبرپراکنی سیاسی، اجتماعی یا مذهبی که جنبه تجاری نداشته باشد</li>
                <li>
                  برنامهها و روشهای عبور از فیلترینگ، VPN و خدمات یا کالاهای مربوط به نصب آنتن، راه
                  اندازی ماهواره یا اینترنت ماهوارهای
                </li>
                <li>بزار یا آموزشهای نفوذ، خرابکاری، شکستن قفل، هک و کرک</li>
                <li>فروش برنامه‌های نرم‌افزاری یا کتابهای فاقد مجوز قانونی برای انتشار و سایر موارد ناقض
                  «قانون حمایت حقوق مؤلفان و مصنفان و هنرمندان»</li>
                <li>هر گونه اجاره و فروش فیلم یا موسیقی</li>
                <li>شبکه‌های هرمی و فعالیتهای غیرقانونی و غیرمجاز اقتصادی مشابه</li>
                <li>هر نوع مسابقه، قرعهکشی و بختآزمایی (با جایزه یا بدون جایزه )</li>
                <li>آگهی انجام پروژههای دانشجویی و دانش آموزی</li>
                <li>هر گونه کالایی که موجب رواج خشونت و آسیب رساندن به دیگران میشود، مانند : <br />
                  سلاحهای گرم و سرد، مواد محترقه و امثال آن</li>
                <li>کالا و خدمات مرتبط با مواد مخدر، سیگار یا ترک اعتیاد</li>
                <li>فروش دستگاه فلزیاب، گنجیاب، حفاری غیرمجاز یا لوازم و تجهیزات مرتبط با آن</li>
                <li>خدمات، دفاتر و شرکتهای مرتبط با لیزینگ به جز نمایندگیهای مجاز با ارائه مجوز</li>
                <li>فروش فاکتور و پیش فاکتور برای اخذ وام، حذف سهم بیمه کارفرما و مشابه آن</li>
                <li>هرگونه خدمات مرتبط با گرینکارت یا اقامت کشورها و مسافرت و اخذ ویزا به کشورهایی
                  که منع قانونی برای ورود به آنها وجود دارد</li>
                <li>درج شماره حساب در متن آگهی</li>
                <li>درج شماره حساب در متن آگهی</li>
                <li>معرفی سایت، کالا یا خدماتی که به هر شکلی قصد رقابت با صنعتبان را دارند</li>
                <li>درج آگهی خودروهای غیر قابل خرید و فروش در ایران</li>
                <li>درج مکرر آگهی‌های یکسان حتی با عناوین متفاوت در یک روز</li>
                <li>ارسال مجدد یک آگهی که از زمان حذف آن توسط کاربر، بیش از ۲۴ ساعت سپری نشده
                  باشد</li>
                <li>قرار ملاقات غیرتجاری به صورت آنلاین</li>
                <li>وجود جملات نادرست از نظر املائی یا نگارشی و فحاشی</li>
                <li>آگهی‌های فروش سیم کارت که شمار آگهی درج نشده باشد</li>
                <li>هرگونه سوءاستفاده از شماره تلفن همراه یا نشانی پست الکترونیکی دیگران پیگرد قانونی
                  دارد و آگهی دهنده مسئول آن تلقی شده و صنعتبان در این مورد هیچ گونه مسئولیتی
                  ندارد
                </li>
              </ul>
            </div>

            <div className="mt-5">
              <h5 className="text-center mb-4">
                شرایط تصاویر آگهی‌ها
              </h5>
              <p>
                پیشنهاد میکنیم همواره از تصاویر واقعی، باکیفیت و مرتبط با کالا یا خدمتی که ارائه مینمایید ، استفاده کنید
                نداز بایست حداقل ۶۰۰*۶۰۰ و حجم آن حداکثر ۱۰ مگابایت باشد. چنانچه
                یک یا چند بند از موارد زیر برای تصویر آگهی شما صدق کند، تصویر منتشر نمیشود :
              </p>

              <ul className="pe-4 mt-3">
                <li> مغایرت با قوانین جاری جمهوری اسلامی ایران و عرف جامعه </li>
                <li>  تصویر لوگو </li>
                <li>  تصویر بیش از حد کوچک یا بیکیفیت </li>
                <li>تصویر غیر واقعی</li>
                <li>  تصویر دارای کادری سیاه (یا سایر رنگها) </li>
                <li> مغایرت محتوای تصویر با شرایط عرف جامعه و یا قوانین جمهوری اسلامی</li>
                <li>ستفاده ابزاری از تصاویر اشخاص در آگهی</li>
                <li>تصویری که متعلق به آگهی دیگری در صنعتبان باشد</li>
                <li>تصویری که به آگهی مرتبط نباشد</li>
                <li>بیش از ٪۲۰ از محتوا ِی تصویر آگهی شامل متن باشد</li>
                <li> تصویر نیاز به چرخش داشته باشد </li>
                <li>  در تصویر آگهی عبارتهای تبلیغاتی یا واژههایی مانند: حراج و ... نوشته شده باشد </li>
                <li> تصاویری که دارای شماره تماس، ایمیل یا آدرس سایت باشند </li>
              </ul>
              <p>
                *
                در دسته‌بندی استخدام و کاریابی و همچنین دستهبندی خدمات امکان ثبت تصویر لوگوی شرکت و
                مجموعه وجود دارد
              </p>
            </div>

            <div className="mt-5">
              <h5 className="text-center mb-4">
                شرایط مشاهده و استفاده از آگهی‌ها
              </h5>
              <p>
                هرگونه استفاده از صنعتبان به معنی پذیرفتن شرایط مندرج در این سایت است. صنعتبان هیچ
                توافقی با کاربران خارج از این شرایط ندارد. شرایط زیر مربوط به کسانی است که به هر شکلی از
                آگهی ٔ های منتشر شده صنعتبان استفاده میکنند .
              </p>

              <ul className="pe-4 mt-3">
                <li> تلاش صنعتبان، نشر آگهی‌ها با اطلاعات صحیح و درست است اما نمیتواند صحت آگهی‌ها
                  را تضمین نماید و هیچگونه تعهد یا مسئولیتی در قبال آگهی‌ها برعهده نمیگیرد </li>
                <li>
                  های این سایت بر عهده صنعتبان هیچ تعهدى در مسئولیت استفاده از آگهی شماست و
                  قبال خسارات مستقیم، اتفاقى، تبعى، غیرمستقیم و کیفرى، ناشى از دسترسى و استفاده
                  شما از این سایت ندارد
                </li>
                <li>
                  صنعتبان هیچ قرارداد، تعهدنامه یا سندی را با آگهیدهندگان حقیقی یا حقوقی منعقد نمی کند.
                  کاربرا صنعتبان در هر لحظه قادر به ویرایش آگهی خود هستند، بنابراین
                  صنعتبان، هیچگونه مسئولیتی را در قبال هر نوع آگهی درج شده در سایت نمیپذیرد و
                  صرفاً مطالب درج شده توسط کاربران را نمایش میدهد
                </li>
                <li>
                  مسئولیت استفاده از هرگونه متن، پیام، توضیح، اطلاعات، عکس، مشخصات تماس و موارد
                  مشابه که به صنعتبان ارسال میشود یا در آن قرار میگیرد، شامل بازتولید، افشاء، مخابره،
                  نشر و پخش آن بر عهد ٔه فرستنده اطلاعات است
                </li>

                <li>
                  صنعتبان مختار است هر گونه پیام، آگهی یا عکسی که به این سایت ار سال میکنید یا هر
                  حساب کاربری و اطلاعات دیگری که مربوط به شما یا ایجاد شده توسط شما باشد را هر
                  زمانی و به هر شکلی که ضروری بداند حذف نماید
                </li>
                <li>
                  مسئولیت هر لینک، مطلب و ادعایی مربوط به صنعتبان ٔ که به واسطه اشخاص حقیقی و
                  حقوقی دیگر در سایت، بلاگ یا شبکههای اجتماعی و باقی رسانهها منتشر میشود، با خود
                  این افراد است و صنعتبان مسئولیتی در قبال آنها ندارد
                </li>
                <li>
                  آگهی‌های صنعتبان ٔ با هزینه گردانندگان سایت جمعآوری، نظارت، مرتبسازی و توزیع شده
                  است و حق حذف آگهی‌ها در هر زمان به ارسالکننده آگهی داده شده است. استفاده کننده
                  از صنعتبان حق کپیبرداری از اطلاعات آگهیدهنده، نوشتار و تصاویر آگهی‌های ارسال شده
                  به صنعتبان را چه به شکل دستی و یا خودکار نخواهد داشت و انجام این موارد پیگرد قانونی
                  دارد
                </li>
                <li> قوانین جمهوری اسلامی ایران بر تعبیر، تفسیر، اجرا و تأثیر این توافقنامه حاکم خواهند بود </li>
              </ul>

            </div>

            <div className="mt-5">
              <h5 className="text-center mb-4">
                شرایط استفاده از امکانات ارتباطی
              </h5>
              <p>
                صنعتبان برخی امکانات ارتباطی از قبیل چت را با هدف تسهیل ارتباطات، کاهش مزاحمتها و
                افزایش معاملات ارائه میکند. صحبتهای کاربران صرفاً باید مربوط به آگهی خاص و در خصوص
                ارائه و یا دریافت کالا و خدمات مورد اشاره باشد و استفاده از آن بابت مقاصد دیگر از جمله
                ارتباطات خصوصی مجاز نیست. صنعتبان برای ایجاد محیطی ایمن برای معاملات، ضمن
                ذخیرهسازی اطلاعات ارتباطی و تحلیل خودکار آنها، بر اساس یافتههای هوش مصنوعی، پیشنهادات
                و خدماتی را بر روی ابزارهای ارتباطی خود ارائه میکند. لذا لازم به یادآوری است که بر خلاف
                محیطهای ارتباطی دیگر که مشمول استانداردهای حریم شخصی است، ارتباطات روی صنعتبان
                صرفاً باید مربوط به معاملات باشد و صنعتبان برای ایجاد محیطی ایمن و جلوگیری از سوءاستفاده
                .و مزاحمت، بر روی این ابزارها ممکن است در صورت لزوم، نظارت ماشینی یا انسانی صورت دهد
              </p>
              <h6 className="text-center mt-4 mb-3">
                امن خرید کنید
              </h6>
              <ul className="pe-4 mt-3">
                <li>
                  از کسانی خرید کنید که امکان ملاقات حضوری با آنها پیش از انجام معامله وجود داشته  باشد
                </li>
                <li> هرگز پیش از دریافت کالا هزینهای پرداخت نکنید </li>
                <li>
                  اگر فروشنده اطلاعات شخصی یا اطلاعات حساب بانکی خود را ارائه کرد، دلیل کافی برای
                  اعتماد شما به ایشان نیست؛ ممکن است اطلاعات شخص دیگری مورد سوءاستفاده قرار
                  گرفته باشد
                </li>
                <li> در صورت امکان، پس از خرید کالا رسید کتبی معتبر از فروشنده دریافت کنید </li>
              </ul>

              <h6 className="text-center mt-4 mb-3">
                بیشتر احتیاط کنید وقتی ...
              </h6>
              <ul className="pe-4 mt-3">
                <li>
                  قیمت و شرایط ارائه شده بیش از حد عالی به نظر میرسد
                </li>
                <li>فروشنده یا خریداری که بیدلیل و به طرزی مشکوک اطلاعات حساب بانکی شما را میپرسد </li>
                <li>
                  میخواهید مبلغ قابل توجهی به کسی که نمیشناسید، بپردازید. سعی کنید در محلی امن
                  مانند پایگاههای پلیس یا شعب بانکها قرار بگذارید
                </li>
                <li> در صورت امکان، پس از خرید کالا رسید کتبی معتبر از فروشنده دریافت کنید </li>
              </ul>

              <h6 className="text-center mt-4 mb-3">
                به خاطر داشته باشید :
              </h6>
              <ul className="pe-4 mt-3">
                <li>
                  در خرید پستی، شما پیش از اطمینان از صحت کالا هزینه را پرداخت کردهاید که این مورد
                  خالی از ریسک نیست و ما انجام آن را به هیچ عنوان توصیه نمیکنیم
                </li>
                <li>
                  بهتر است نقدی معامله کنید. چک و سفته ممکن است نقد نشوند
                </li>
                <li>در مورد برخی کالاها بهتر است درخواست فاکتور خرید و احیاناً بستهبندی اولیه را از
                  فروشنده داشته باشید
                </li>
                <li>بهتر است قبل از تحویل کالا یا دستگاه خود در ازای چکهای رمزدار بانکی، با مراجعه به
                  بانک مربوط از اصالت آن اطمینان حاصل کنید</li>
                <li> در صورت ایجاد مزاحمت برای شما، میتوانید با مراجعه به سایت پلیس فتا، از اطلاعات
                  تماس پلیس فتای محل سکونت خود آگاه شده و موضوع را از آن طریق پیگیری کنید </li>
              </ul>

            </div>

            <div className="mt-5">
              <h5 className="text-center mb-4">
                امکانات ویژه برای آگهی‌ها
              </h5>
              <p>
                درج آگهی در تمامی دستهبندیهای صنعتبان به جز دستهبندی »استخدام و
                کاریابی« رایگان است، البته شما میتوانید با انتخاب هر یک از مواردی که در ادامه ذکر شدهاند،
                سریعتر و بهتر مخاطبان آگهی‌های خود را پیدا کنید
              </p>
              <p>درج آگهی در تمامی دستهبندیهای صنعتبان به جز دستهبندی »استخدام و
                کاریابی« رایگان است، البته شما میتوانید با انتخاب هر یک از مواردی که در ادامه ذکر شدهاند،
                سریعتر و بهتر مخاطبان آگهی‌های خود را پیدا کنید
              </p>
            </div>

          </div>
        </div>

        <div className="col-4 pt-5">
          <img width={"100%"} src={require("../../Assets/images/terms.png")} />

        </div>
      </div>
    </div >
  );
};

export default Terms;
